var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticStyle: { display: "none" } }, [_vm._t("default")], 2),
      _c("h1", [_vm._v(_vm._s(_vm.$t("newTrip.title")))]),
      _c("router-view", [_vm._t("default")], 2)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }